import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "WebPutty will make your CSS cry virgin unicorn tears of awesome",
  "description": "",
  "published": "2011-07-28T00:00:00.000Z",
  "redirect_from": ["/blog/webputty-will-make-your-css-cry-virgin-unicorn-tears-of-awesome/swizec/2008"],
  "categories": "CSS, Fog Creek Software, Style Sheets, Tools, Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`First thing's first: I `}<em parentName="p">{`hate`}</em>{` IDE's.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/07/Screen-Shot-2011-07-27-at-1.35-300x179.png",
        "alt": null,
        "title": "Bestest design I've ever done"
      }}></img></p>
    <p>{`Second thing's second: I absolutely `}<em parentName="p">{`suck`}</em>{` at design.`}</p>
    <p>{`You can see proof of the first by ... well hmm ... I'm not sure I can find a blog post where I cry about the aches and pains an IDE forces upon me right now, but I'm sure if you've ever talked to me about code editors and such you'd soon see my deep deep hatred of the bloat that is an IDE.`}</p>
    <p>{`Proof that I'm not even a passable designer can easily be found in the last pet project I've pushed out into the open, `}<a parentName="p" {...{
        "href": "http://githubfriends.swizec.com"
      }}>{`GithubFriends`}</a>{`. It's just a horrible mess, I tried to make it awesome, honestly, I tried!`}</p>
    <p><em parentName="p">{`tl;dr --> WebPutty will make your `}<a parentName="em" {...{
          "href": "http://en.wikipedia.org/wiki/Cascading_Style_Sheets",
          "title": "Cascading Style Sheets"
        }}>{`CSS`}</a>{` cry virgin unicorn tears of awesome`}</em></p>
    <p>{`Thing is, despite my pretty solid knowledge of CSS and browsers (I used to make a living as an implementor of designers' crazy wishes) and a good eye for design ... by good eye I mean that I can recognise a good design when I see it. This came mostly from spending a lot of time hanging out with designers.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/07/Screen-Shot-2011-07-28-at-11.35.51-AM-300x176.png",
        "alt": null,
        "title": "GithubFriends"
      }}></img></p>
    <p>{`I've even gotten so bad as to care about `}<em parentName="p">{`fonts.`}</em>{` Fonts man! Fonts.`}</p>
    <p>{`Clearly, the knowledge of how to implement a design and being able to recognise a good design when you see it isn't enough to make you a good designer. The real designers, the one that actually call themselves such, have something extra. That magical voodoo ability to pull a good design out of thin air.`}</p>
    <p>{`Similarly to how a developer sees an algorithm before it is implemented, so too does a good designer see his design before the first line is put down in `}<a parentName="p" {...{
        "href": "http://www.adobe.com/products/indesign/main.html",
        "title": "Adobe InDesign"
      }}>{`InDesign`}</a>{`.`}</p>
    <p>{`So how can a schmuck like me create a website that doesn't offend the eye then?`}</p>
    {
      /*more*/
    }
    <h2 {...{
      "id": "enter-webputty-stage-left"
    }}>{`Enter WebPutty, stage left`}</h2>
    <p>{`Barely a week ago `}<a parentName="p" {...{
        "href": "http://www.fogcreek.com",
        "title": "Fog Creek Software"
      }}>{`Fog Creek Software`}</a>{` released their newest tool for us poor schmucks.`}</p>
    <p>{`It's a website. That is also an IDE. Made for editing CSS.`}</p>
    <p>{`The idea is pretty simple. You can write the CSS and you can see when something looks good. So why not edit the CSS and immediately see whether it looks good or not?`}</p>
    <p>{`Right? Right. Brilliant!`}</p>
    <p>{`Here's what it looks like when I work on my latest pet project, which I will not link to because it is not yet ready for the public (and I'm too lazy to implement beta locks and whatnot, if you know the url, have at it, leave me feedback ;)`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/07/Screen-Shot-2011-07-28-at-11.42.12-AM-e1311879209766.png",
        "alt": null,
        "title": "WebPutty + thefantastic.me"
      }}></img></p>
    <p>{`The whole idea is pretty simple. On the left you see the website you're working on and on the right is the CSS you're editing. Everything you do immediately reflects in the page.`}</p>
    <p>{`What makes this arrangement so much better than the traditional InDesign approach is that you can intereact with the site and make sure everything works. Things hidden behind javascript actions can be easily styled and so on. It's pretty brilliant.`}</p>
    <p>{`Plus, if your site only works on localhost, WebPutty doesn't care! It still works :D`}</p>
    <p>{`In conclusion, I think my CSS editing workflow has been changed forever.`}</p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.readwriteweb.com/hack/2011/07/webputty-browser-based-css-editor.php"
        }}>{`WebPutty: Browser Based CSS Editing Made Easy`}</a>{` (readwriteweb.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://blog.fogcreek.com/webputty-css-editing-goes-boink/"
        }}>{`WebPutty: CSS editing goes "boink"`}</a>{` (fogcreek.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.webputty.net/"
        }}>{`Fog Creek releases WebPutty`}</a>{` (webputty.net)`}</li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=e366686c-293f-4e71-84a1-22fd7cc4b581",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      